import * as React from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"
import SectionSpeakers from "../components/section-speakers"
import SectionSchedule from "../components/section-schedule"
import SectionUpdates from "../components/section-updates"
import SectionInfo from "../components/section-info"
import "bootstrap/dist/css/bootstrap.min.css"
import HeroSlider from "../components/hero-slider"
import NamesInfoBlock2 from "../components/names-info-block-2"
import CalloutCard from "../components/callout"

const IndexPage = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Event",
    name: "CSIConference",
    description:
      "CSICon is the premier conference in the US for science and skepticism. Don't miss out. Register today.",
    image:
      "https://cdn.centerforinquiry.org/wp-content/uploads/sites/29/2024/04/10121848/CSICon2024_Banner_v1.png",
    startDate: "2024-10-24",
    endDate: "2024-10-27",
    eventAttendanceMode: "https://schema.org/OfflineEventAttendanceMode",
    location: {
      "@type": "Place",
      name: "Horseshoe Las Vegas",
      address: {
        "@type": "PostalAddress",
        addressLocality: "Las Vegas",
        addressRegion: "NV",
        postalCode: "89101",
        addressCountry: "US",
      },
    },
    breadcrumb: {
      "@context": "https://schema.org/",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Registration",
          item: "https://csiconference.org/registration/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Hotel Information",
          item: "https://csiconference.org/hotel/",
        },
      ],
    },
  }

  return (
    <div className="page-template-home-page">
      <Layout>
        <Seo title="CSICon Homepage" schemaMarkup={schema} />
        <HeroSlider />
        <SectionSpeakers />
        {/*removing info block to clean up the layout. add back maybe somehwere cleaner when we have info<InfoBlock />*/}
        <SectionSchedule />
        <NamesInfoBlock2 />
        <CalloutCard />
        {/*The callout card components should be refactored, the original did not use destructuring */}
        {/*Removing info section so there is no 2024 info on the live site />*/}
      </Layout>
    </div>
  )
}

export default IndexPage
